import React from "react";
import styles from "./styles/ServiceCentreCTA.module.css";
import Icon from "../Home/common/Icon";
import ctaBg from "../../../images/contact-cta.jpg";

export default function ServiceCentreCTA() {
  return (
    <section className={styles.cta} style={{ backgroundImage: `url(${ctaBg})` }}>
      <div className={styles.overlay} aria-hidden="true" />
      <div className={styles.container}>
        <p className={styles.text}>
          We are an authorised service center for Mitsubishi FA in Gurgaon India and you can be
          rest assured of our service just as Mitsubishi does.
        </p>
        <a href="/contact" className={styles.ctaBtn}>
          <span className={styles.ctaIcon} aria-hidden="true">
            <Icon.Phone />
          </span>
          <span>CONTACT US</span>
        </a>
        <div className={styles.divider} aria-hidden="true" />
      </div>
    </section>
  );
}
